const NumberFix = function(value, fix) {
    if (!value) {
        return 0
    }
    let num = Number(value)
    if (isNaN(num)) {
        return 0
    }
    if (!fix) {
        return num
    }
    let roundNum = Math.pow(100, fix / 2)
    num = Math.round(num * roundNum)
    num = parseFloat(num / roundNum).toFixed(fix)
    return Number(num)
}

// 表单校验
// 边界值校验
export const validatorNumber = (msg, minNumber = 0, item, key, tijiao = true) => {
    return (rule, value, callback) => {
        value = item[key] // 这里是为了防止-model时候，实际上value没有同步更新
        if (NumberFix(value, 6) <= minNumber && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

export const lt = (msg, minNumber = 0, item, key, tijiao = true) => {
    return (rule, value, callback) => {
        value = item[key] // 这里是为了防止-model时候，实际上value没有同步更新
        if (NumberFix(value, 6) < minNumber && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

export const ne = (msg, number = 0, item, key, tijiao = true) => {
    return (rule, value, callback) => {
        value = item[key] // 这里是为了防止-model时候，实际上value没有同步更新
        let error = true
        if (NumberFix(value, 6) < number || NumberFix(value, 6) > number) {
            error = false
        }
        if (error && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

// 大小值比较
export const validatorDiff = (msg, item, minNumberKey, maxNumberKey, tijiao = true) => {
    return (rule, value, callback) => { // 不传-取value
        let maxNumber = maxNumberKey !== 0 ? item[maxNumberKey] : 0
        let min = minNumberKey ? item[minNumberKey] : value
        if (NumberFix(min, 6) > NumberFix(maxNumber, 6) && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

// step比较
export const validatorStep = (msg, item, stepKey, minKey, tijiao = true) => {
    return (rule, value, callback) => { // 不传-取value
        let stepNumber = stepKey !== 0 ? item[stepKey] : 0
        if ((value - (item[minKey] || 0)) % NumberFix(stepNumber, 6) > 0 && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

// 数据为空
export const validatorEmpty = (msg, item, key, tijiao = true) => {
    return (rule, value, callback) => {
        value = item[key]
        if (!value && tijiao) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

// 浮点输入校验
export const inputValidFloat = (value, fix = 6, int = true) => {
    if (typeof value.replace === 'undefined') {
        return value
    }
    let inputing = false
    if (value.indexOf('.') == value.length - 1) {
        inputing = true
    } else if (value == '0.0'||value == '0.00'||value == '0.000'||value == '0.0000'||value == '0.00000'||value == '0.000000') {
        inputing = true
    } else if (value.indexOf('-') == value.length - 1) {
        inputing = true
    }
    if (!inputing && fix) {
        value = NumberFix(value, fix)
    }
    value = value.toString()
    switch (fix) {
        case 6:
            value = int ? value.replace(/[\D]|(\.*)(\d+)(\.?)(\d{0,6}).*$/g, '$2$3$4') : value.replace(/[^(\-)0-9]|(\.*)(\d+)(\.?)(\d{0,6}).*$/g, '$2$3$4')
            break;
        case 2:
            value = int ? value.replace(/[\D]|(\.*)(\d+)(\.?)(\d{0,2}).*$/g, '$2$3$4') : value.replace(/[^(\-)0-9]|(\.*)(\d+)(\.?)(\d{0,2}).*$/g, '$2$3$4')
            break;
        case 4:
            value = value.replace(/[\D]|(\.*)(\d+)(\.?)(\d{0,4}).*$/g, '$2$3$4')
            break;
        default:
            break;
    }
    return value
}

// 整数校验
export const inputValidInt = (value) => {
    if (typeof value.replace === 'undefined') {
        return value
    }
    value = value.replace(/\D/g, '')
    return value
}

// 允许负数整数
export const inputValidNegInt = (value) => {
    if (typeof value.replace === 'undefined') {
        return value
    }
    value = value.replace(/[^(\-)0-9]/g, '')
    return value
}
// 手机号校验
export const validateMobile = (msg) => {
    return (rule, value, callback) => {
        const reg = /^1\d{10}$/
        if (!reg.test(value)) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

/**客服号校验 */
export const validServicePhone = (rule, value, cb) => {
    const tel = /^1\d{10}$/;
    const zoneTelTypeOne = /0\d{2}-\d{7,8}/; // 以"-"区分的区号+8座机号码
    const zoneTelTypeTwo = /\((0\d{2})\)\d{7,8}/; // 以"()"区分的区号+8座机号码
    const isTel = tel.test(value); //是否是手机号
    const isZoneTel = (zoneTelTypeOne.test(value) && value.length === 12) || (zoneTelTypeTwo.test(value) && value.length === 13); // 测试是否是区号+8位数座机号
    const isSerTel = value.length === 10 && value[0] == '4' && value[1] == '0' && value[2] == '0' //是否是客服号
    // console.log(zoneTelTypeTwo.test(value), value, value.length)
    if (isTel || isSerTel || isZoneTel) {
        cb()
    } else {
        cb(new Error('请输入正确的客服号码'))
    }
    // validFormat('tel', '请输入正确的客服号码')
}

/**校验图片是否为空 */
export const validEmptySimple = msg => {
    return (rule, value, callback) => {
        if (!value.length) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}

/**校验物品 */
export const validGoods = msg => {
    return (rule, value, callback) => {
        if (!value) {
            callback(new Error(msg));
        } else {
            callback();
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/validator.js